import script from "./ResidentSmetaMaterialsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ResidentSmetaMaterialsTable.vue?vue&type=script&setup=true&lang=js"

import "./ResidentSmetaMaterialsTable.vue?vue&type=style&index=0&id=3495ef2d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3495ef2d"]])

export default __exports__